
var userAgent = navigator.userAgent.toLowerCase();
var is_safari = /^((?!chrome|android).)*safari/i.test(userAgent);

var videoOptions = {
    nativeControlsForTouch: false,
    controls: true,
    inactivityTimeout: 5000,
    html5: {
        nativeAudioTracks: is_safari,
        nativeVideoTracks: is_safari,
        hls: {
            withCredentials: false,
            overrideNative: !is_safari,
        },
    },
    plugins: {
    },
};

/**
 * IE 11 handlings
 */
var is_ie = userAgent.indexOf("msie ") > -1 || !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

if(is_ie) {
    videoOptions.flash = {
        swf: '/plugins/videojs/video-js.swf',
    };
    videoOptions.techOrder = ['flash', 'html5'];
    $('body').addClass('ie-browser');

    if(JavascriptHandler.Path == "/tv/") {
        $('.global-video-player-wrapper')
            .html('<div class="container"> <div class="medium-insert-embed"> <div class="video"> <iframe width="1280" height="720" src="https://www.youtube.com/embed/df-97lhZBi0?autoplay=1&amp;rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> </div> </div></div>')
            .removeClass('global-videoplayer');
        $('.live-show').remove();
    }
}
/**
 * End of IE 11 Handlings
 */

var isAndroid = userAgent.indexOf("android") > -1;

if (isAndroid) {
    videoOptions = {
        nativeControlsForTouch: false,
        controls: true,
        inactivityTimeout: 5000,
        // html5: {
        //     nativeAudioTracks: false,
        //     nativeVideoTracks: false,
        //     hls: {
        //         // useBandwidthFromLocalStorage:  $(window).width() > 1000 ? true : false,
        //         withCredentials: true,
        //         overrideNative: true,
        //     },
        // },
        plugins: {

        },    };
    $('body').addClass('device-android');
}


export var options = videoOptions;